exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/dashboard-superadmin/dashboard-superadmin.component.css
// module id = ../../../../../src/app/logistics-operations/dashboard-main/dashboard-superadmin/dashboard-superadmin.component.css
// module chunks = main